import { GET_TILE_RECIPES_SUCCESS } from "../actionTypes";

const initialState = []

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_TILE_RECIPES_SUCCESS: {
      const tileRecipes = action.payload;

      if (!tileRecipes){
        return {...state};
      }

      return [...state, ...action.payload]
    }

    default:
      return state;
  }
}
